module.exports = __webpack_public_path__ + "img/operationCapacity4.672013e3.png";